import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { reportError, setRollbarUser, clearRollbarUser } from './lib/rollbar'
import './style.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Catch errors raised inside Vue components and forward to Rollbar.
// Re-throw via console.error so dev still sees the noisy original.
app.config.errorHandler = (err, _instance, info) => {
  console.error('[vue errorHandler]', err, info)
  reportError(err, { vueInfo: info })
}

const auth = useAuthStore()

// Keep the Rollbar "person" context in sync with the signed-in user.
// Fires when fetchProfile lands after login, when the user logs out,
// and any other path that mutates profile.
watch(
  () => auth.profile,
  (profile) => {
    if (profile) setRollbarUser(profile)
    else clearRollbarUser()
  },
  { immediate: true },
)

auth.init().then(() => {
  app.use(router)
  app.mount('#app')
})
